import React, { useState } from 'react';
import logo_close from '../assets/close-check.png';
import '../styles/Connexion.css';
import GoogleLoginButton from './GoogleLoginButton';
import FacebookLoginButton from './FacebookLoginButton';

function Connexion() {

    const [isformConnexion, setisformConnexion] = useState(false)
    const [emailValue, setEmailValue] = useState('')
    const [isDataRegistering, setIsDataRegistering] = useState(false)
    const [isConnexionMailSend, setisConnexionMailSend] = useState(false)
    const [isCompleted, setIsCompleted] = useState(false)
    const [isError, setError] = useState(false)
    const [tmpKey, setTmpKey] = useState('')

    if (tmpKey === '') {
        const timestamp = Date.now();
        setTmpKey(timestamp);
    }

    function handleInputMail(e) {
        setEmailValue(e.target.value)
    }

    async function requestConnexion() {
        if (isValidEmail(emailValue)) {
            sendConnexionMail(emailValue)
        }
        else {
            alert("Attention, ceci n'est pas une adresse valide 😥")
        }
    }

    async function sendConnexionMail(p_email) {

        console.log("registerReservation debut");
        const requestOptions = {
            method: "POST",
            mode: 'cors',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                email: p_email
            }),
        };

        try {
            let v_responseJson = {};
            console.log("tmpKey " + tmpKey);
            setIsDataRegistering(true)
            const response = await fetch("https://app.listaki.fr/api/WS/sendAccessLink.php?key=" + tmpKey, requestOptions)
            if (response.ok) {
                v_responseJson = await response.json();
                console.log("Reponse api debut");
                console.log(v_responseJson)
                console.log("Reponse api fin");
                if (v_responseJson["success"]) setisConnexionMailSend(true)
                else alert(v_responseJson["error"])
                setIsCompleted(true);
            } else {
                console.log("Erreur lors de l'appel à l'API");
                v_responseJson = await response.json();
                if (v_responseJson["error"]) alert(v_responseJson["error"])
                setError(true);
            }
        } catch (err) {
            console.log(err)
        } finally {
            setIsDataRegistering(false)
        }
    };

    function isValidEmail(p_email) {
        console.log(p_email);
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(p_email);
    }
    function closeAll() {
        setisConnexionMailSend(false)
        setisformConnexion(false)
    }

    return !isConnexionMailSend & isformConnexion ? (
      <div className="ui-overlay">
        <div className="ui-modal">
          <img src={logo_close} alt="Fermer" onClick={() => setisformConnexion(false)} className='kdo-logoclose' />
          <div className='kdo-connexion-box'>
            <div className="kdo-connexion-logo">
              <div className="kdo-connexion-logo-square" />
              <span className="kdo-connexion-logo-text">Listaki</span>
            </div>
            <h2>Bienvenue !</h2>
            <p className="kdo-connexion-subtitle">Entrez votre e-mail pour recevoir votre lien de connexion.</p>
            <label className="kdo-connexion-label">Adresse e-mail</label>
            <input
              className='kdo-connexion-input'
              type="email"
              placeholder='votre@email.fr'
              onChange={handleInputMail}
              autoFocus
            />
            <button
              className="kdo-connexion-cta"
              disabled={isDataRegistering}
              onClick={() => {
                if (window.umami) window.umami.track('login-mail-click');
                requestConnexion();
              }}
            >
              {isDataRegistering ? 'Envoi en cours…' : 'Recevoir mon lien de connexion'}
            </button>
            <p className="kdo-connexion-hint">Un lien valable 15 minutes vous sera envoyé.</p>
            <div className="kdo-connexion-divider">
              <span className="kdo-connexion-divider-line" />
              <span className="kdo-connexion-divider-text">ou</span>
              <span className="kdo-connexion-divider-line" />
            </div>
            <div className="google-button-wrapper">
              <GoogleLoginButton />
            </div>
            <div className="fb-button">
              <FacebookLoginButton />
            </div>
            <div className="kdo-connexion-footer">
              Pas encore de compte ? <a href="/register">Créer un compte</a>
            </div>
          </div>
        </div>
      </div>
    ) : isConnexionMailSend & isformConnexion ? (
      <div className="ui-overlay">
        <div className="ui-modal">
          <img src={logo_close} alt="Fermer" onClick={() => closeAll()} className='kdo-logoclose' />
          <div className='kdo-connexion-box'>
            <div className="kdo-connexion-success">
              <span className="kdo-connexion-success-icon">✅</span>
              <h2>Email envoyé !</h2>
              <p>Si vous êtes inscrit, vous recevrez un e-mail avec votre lien de connexion.<br />Vérifiez vos spams si vous ne le trouvez pas.</p>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <p>Vous avez déjà un compte ? <a href="#" onClick={() => setisformConnexion(true)}>Se connecter</a></p>
    )
};

export default Connexion;